"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SideBar_1 = __importDefault(require("@components/SideBar"));
var react_1 = __importStar(require("react"));
var Input_1 = __importDefault(require("@components/Input"));
var Button_1 = __importStar(require("@components/Button"));
var react_i18next_1 = require("react-i18next");
var DateFilterInput_1 = __importDefault(require("./DateFilterInput"));
var NumberFilterInput_1 = __importDefault(require("./NumberFilterInput"));
var CustomSelect_1 = __importDefault(require("@/react-app/common/components/CustomSelect"));
var implioFilters_1 = require("./implioFilters");
var userSettings_1 = require("@/react-app/common/utils/userSettings");
var useFocusEffect_1 = require("./hooks/useFocusEffect");
var utils_1 = require("./utils");
function FilterSideBar(_a) {
    var refusalReasons = _a.refusalReasons, feedbacks = _a.feedbacks, rules = _a.rules, isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, chips = _a.chips, focusFilterId = _a.focusFilterId, setFocusFilterId = _a.setFocusFilterId, setSearchParams = _a.setSearchParams, searchSidebarFiltersLocalStorage = _a.searchSidebarFiltersLocalStorage, currentUser = _a.currentUser, domain = _a.domain, setSelectedJobRows = _a.setSelectedJobRows;
    var _b = __read((0, react_1.useState)({}), 2), filterValues = _b[0], setFilterValues = _b[1];
    var _c = __read((0, react_1.useState)({}), 2), issues = _c[0], setIssues = _c[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var _d = __read((0, react_1.useState)([]), 2), expandedFilterGroups = _d[0], setExpandedFilterGroups = _d[1];
    var sortedFeedbacks = (0, react_1.useMemo)(function () { return (0, utils_1.sortItems)((0, utils_1.mapFeedbacks)(feedbacks)); }, [feedbacks]);
    var sortedRefusals = (0, react_1.useMemo)(function () { return (0, utils_1.sortItems)((0, utils_1.mapRefusals)(refusalReasons)); }, [refusalReasons]);
    var sortedRules = (0, react_1.useMemo)(function () { return (0, utils_1.sortItems)((0, utils_1.mapRules)(rules)); }, [rules]);
    var implioFiltersWithItems = implioFilters_1.implioFilters.map(function (filter) {
        if (filter.id === implioFilters_1.filterKey.feedbackName) {
            return __assign(__assign({}, filter), { items: sortedFeedbacks });
        }
        if (filter.id === implioFilters_1.filterKey.decisionName) {
            return __assign(__assign({}, filter), { items: sortedRefusals });
        }
        if (filter.id === implioFilters_1.filterKey.filterName) {
            return __assign(__assign({}, filter), { items: sortedRules });
        }
        return filter;
    });
    var implioFilterGroupsWithItems = implioFilters_1.implioFilterGroups.map(function (filterGroup) {
        var filtersWithItems = filterGroup.filters.map(function (filter) {
            if (filter.id === implioFilters_1.filterKey.feedbackName) {
                return __assign(__assign({}, filter), { items: sortedFeedbacks });
            }
            if (filter.id === implioFilters_1.filterKey.decisionName) {
                return __assign(__assign({}, filter), { items: sortedRefusals });
            }
            if (filter.id === implioFilters_1.filterKey.filterName) {
                return __assign(__assign({}, filter), { items: sortedRules });
            }
            return filter;
        });
        return __assign(__assign({}, filterGroup), { filters: filtersWithItems });
    });
    var inputRefs = implioFiltersWithItems.reduce(function (acc, filter) {
        acc[filter.id] = (0, react_1.useRef)(null);
        return acc;
    }, {});
    var updateFilterValues = function (chips) {
        var newFilterValues = chips.reduce(function (acc, chip) {
            acc[chip.id] = chip.value;
            return acc;
        }, {});
        setFilterValues(newFilterValues);
    };
    var handleInputChange = (0, react_1.useCallback)(function (id, value) {
        setFilterValues(function (prevValues) {
            var _a;
            if (value.trim() === '') {
                var _b = prevValues, _c = id, ignored = _b[_c], rest = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
                return rest;
            }
            return __assign(__assign({}, prevValues), (_a = {}, _a[id] = value, _a));
        });
    }, []);
    var setIssueForFilter = (0, react_1.useCallback)(function (id, issue) {
        setIssues(function (prevIssues) {
            var _a;
            if (issue.trim() === '') {
                var _b = prevIssues, _c = id, ignored = _b[_c], rest = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
                return rest;
            }
            return __assign(__assign({}, prevIssues), (_a = {}, _a[id] = issue, _a));
        });
    }, []);
    var handleExpandIconClick = function (filterGroupIndex) {
        if (expandedFilterGroups.includes(filterGroupIndex)) {
            setExpandedFilterGroups(expandedFilterGroups.filter(function (index) { return index !== filterGroupIndex; }));
        }
        else {
            setExpandedFilterGroups(__spreadArray(__spreadArray([], __read(expandedFilterGroups), false), [filterGroupIndex], false));
        }
    };
    // When a chip is clicked, expand the target group and focus the corresponding input
    (0, useFocusEffect_1.useFocusEffect)(isOpen, focusFilterId, inputRefs, implioFilters_1.implioFilterGroups, setExpandedFilterGroups);
    var handleFilterValuesDependingOnChips = function (chips) {
        var searchInput = document.getElementById('navSearchBox_value');
        setIssues({});
        var updatedChips = __spreadArray([], __read(chips), false);
        if (searchInput.value !== '') {
            updatedChips.push({ id: 'text', value: searchInput.value, hideChip: true });
        }
        updateFilterValues(updatedChips);
    };
    (0, react_1.useEffect)(function () {
        // when opening the sidebar, we need to get the filter values from the chips
        if (isOpen) {
            handleFilterValuesDependingOnChips(chips);
        }
        else {
            setFocusFilterId('');
        }
    }, [isOpen]);
    var applyFilters = function () {
        var _a;
        var searchInput = document.getElementById('navSearchBox_value');
        var textValue = filterValues.text || '';
        if (searchInput != null && searchInput.value !== textValue) {
            searchInput.value = textValue;
        }
        var newChips = Object.keys(filterValues).map(function (key) { return ({ id: key, value: filterValues[key], hideChip: key === 'text' }); });
        var newFilters = newChips
            .filter(function (chip) { return !chip.hideChip; })
            .map(function (chip) { return "".concat(chip.id, ":").concat(chip.value); })
            .join(',;,');
        setSearchParams(function (prevParams) { return (__assign(__assign({}, prevParams), { filters: newFilters, text: textValue })); });
        (0, userSettings_1.saveUserSetting)('searchSidebarFilter', __assign(__assign({}, searchSidebarFiltersLocalStorage), (_a = {}, _a[domain] = newFilters, _a)), currentUser);
        setSelectedJobRows([]);
        setIsOpen(false);
    };
    return (react_1.default.createElement(SideBar_1.default, { isOpen: isOpen, setIsOpen: setIsOpen, title: "Filters" },
        react_1.default.createElement("hr", null),
        react_1.default.createElement("form", { className: "filter-sidebar-body", onSubmit: function (e) {
                e.preventDefault();
                applyFilters();
            } },
            react_1.default.createElement("div", { className: "filter-sidebar-filters" }, implioFilterGroupsWithItems.map(function (filterGroup, index) {
                return (react_1.default.createElement("div", { key: filterGroup.id, "data-filter-type": filterGroup.type },
                    react_1.default.createElement("div", { className: "flex-container", onClick: function () { return handleExpandIconClick(index); } },
                        react_1.default.createElement("h4", { className: "cursor-pointer" },
                            filterGroup.icon,
                            t(filterGroup.name)),
                        react_1.default.createElement("div", { className: "expand-icon-container" }, expandedFilterGroups.includes(index) ? (react_1.default.createElement("i", { className: "implioicons-chevron-down" })) : (react_1.default.createElement("i", { className: "implioicons-chevron-up" })))),
                    react_1.default.createElement("hr", null),
                    expandedFilterGroups.includes(index) &&
                        filterGroup.filters.map(function (filter) {
                            var _a;
                            return (react_1.default.createElement("div", { key: filter.id, "data-filter-type": filter.type },
                                react_1.default.createElement("h4", { className: "cursor-default" },
                                    filter.icon && react_1.default.createElement("i", { className: "implioicons-".concat(filter.icon) }),
                                    t(filter.name)),
                                filter.type === implioFilters_1.filterType.INPUT && (react_1.default.createElement("div", { className: "input-wrap form-control ".concat(issues[filter.id] ? 'focus ng-invalid' : '') },
                                    react_1.default.createElement(Input_1.default, { placeholder: filter.placeholder ? t(filter.placeholder) : undefined, value: filterValues[filter.id] || '', onTextChange: function (text) {
                                            setIssueForFilter(filter.id, filter.regex && text && !text.match(new RegExp(filter.regex))
                                                ? t('SEARCH.SEARCH_QUERY_BUILDER.INVALID_EMAIL')
                                                : '');
                                            handleInputChange(filter.id, text);
                                        }, type: "text", className: "form-control", inputRef: inputRefs[filter.id], id: "filter-input-".concat(filter.id) }),
                                    filterValues[filter.id] && (react_1.default.createElement("i", { className: "implioicons-close", onClick: function () {
                                            handleInputChange(filter.id, '');
                                            setIssueForFilter(filter.id, '');
                                        } })))),
                                filter.type === implioFilters_1.filterType.SELECT && (react_1.default.createElement(CustomSelect_1.default, { options: filter.items || [], value: ((_a = filter.items) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.id === filterValues[filter.id]; })) || null, onChange: function (value) {
                                        return handleInputChange(filter.id, value ? value.id : '');
                                    }, getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.text) || ''; }, getOptionValue: function (option) { return (option === null || option === void 0 ? void 0 : option.id) || ''; }, isClearable: true, isSearchable: true, name: filter.name })),
                                filter.type === implioFilters_1.filterType.MULTISELECT && (react_1.default.createElement(CustomSelect_1.default, { options: filter.items || [], placeholder: filter.placeholder ? t(filter.placeholder) : undefined, getOptionLabel: function (option) { return option.text; }, getOptionValue: function (option) { return option.id; }, value: (filterValues[filter.id] || '')
                                        .split('" AND "')
                                        .map(function (id) { var _a; return (_a = filter.items) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.id === id; }); })
                                        .filter(function (item) { return item; }), onChange: function (value) {
                                        return handleInputChange(filter.id, value.map(function (item) { return item.id; }).join('" AND "'));
                                    }, className: "multi-select", isMulti: true, isSearchable: true, name: filter.name })),
                                filter.type === implioFilters_1.filterType.DATEPICKER && (react_1.default.createElement(DateFilterInput_1.default, { filterId: filter.id, placeholder: filter.placeholder ? t(filter.placeholder) : '', filterValue: filterValues[filter.id], handleInputChange: handleInputChange, inputRef: inputRefs[filter.id], maxNow: filter.dateMaxNow, isOpen: isOpen })),
                                filter.type === implioFilters_1.filterType.NUMBER && (react_1.default.createElement(NumberFilterInput_1.default, { filterId: filter.id, placeholder: filter.placeholder ? t(filter.placeholder) : '', filterValue: filterValues[filter.id], handleInputChange: handleInputChange, inputRef: inputRefs[filter.id], setIssueForFilter: function (issue) { return setIssueForFilter(filter.id, issue); }, isOpen: isOpen })),
                                filter.type === implioFilters_1.filterType.SEPARATOR && react_1.default.createElement("hr", null),
                                issues[filter.id] && react_1.default.createElement("div", { className: "warning-text" }, issues[filter.id])));
                        })));
            })),
            react_1.default.createElement("hr", null),
            react_1.default.createElement("div", { className: "filter-sidebar-buttons" },
                react_1.default.createElement(Button_1.SecondaryButton, { text: "Reset", onClick: function () { return setFilterValues({}); } }),
                react_1.default.createElement(Button_1.default, { text: "Apply", type: "submit", disabled: Object.keys(issues).length > 0 })))));
}
exports.default = FilterSideBar;
